import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { AnalyticsService } from 'src/app/services/administration/analytics.service';
import { CommonService } from 'src/app/services/common.service';

@Component({
  selector: 'app-analytic-dashboards',
  templateUrl: './analytic-dashboards.component.html',
  styleUrls: ['./analytic-dashboards.component.scss']
})
export class AnalyticDashboardsComponent {
  DashboardsList: any = [];
  currentDashboardName: string = "";
  currentDashboardID: string = "";
  user_Org_Accesstoken: string = "";
  grantsCheck: boolean=false;
  private window: Window;
  ISTDashboards: any = [];
  EAPDashboards: any = [];
  CMEDashboards: any = [];
  CHARITYDashboards: any = [];
  SPONSERSHIPDashboards: any = [];
  IST_DisplayName:string="";
  EAP_DisplayName:string="";
  Grants_DisplayName:string="";
  CME_DisplayName:string="";
  Charity_DisplayName:string="";
  Sponsership_DisplayName:string="";

  constructor(
    public analyticsService: AnalyticsService,
    private commonService: CommonService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.window = <any>this.document.defaultView;
  }

  ngOnInit(): void {
    this.getUserDashboards();
    let OrgDetail = this.commonService.getOrganizationObject(localStorage.getItem("orgCode")); 
    if(OrgDetail!=null)
    {
      this.IST_DisplayName=OrgDetail.IST_DISPLAY_NAME;
      this.EAP_DisplayName=OrgDetail.EAP_DISPLAY_NAME;
      this.Grants_DisplayName=OrgDetail.GRANTS_DISPLAY_NAME;
      this.CME_DisplayName=OrgDetail.CME_DISPLAY_NAME;
      this.Charity_DisplayName=OrgDetail.CHARITY_DISPLAY_NAME;
      this.Sponsership_DisplayName=OrgDetail.SPONSERSHIP_DISPLAY_NAME;
      if(OrgDetail.GRANTS == true)
        {
          this.grantsCheck = true;
        }
    }
   
    // this.isLogiBuilder = false;
  }

  getUserDashboards() {
    this.analyticsService.GetUserDashboards().subscribe(response => {
      debugger;
      this.DashboardsList = response.Data;
      this.ISTDashboards = response.Data.ISTData;
      this.EAPDashboards = response.Data.EAPData;
      this.CMEDashboards= response.Data.CMEData;
      this.CHARITYDashboards= response.Data.CharityData;
      this.SPONSERSHIPDashboards= response.Data.SponsershipData;
      this.user_Org_Accesstoken = response.Data.AccessToken;
    })
  }

  embedDashboard(dashboardId: string,DashboardName:string) {
    this.currentDashboardID=dashboardId;
    this.analyticsService.FetchUpdatedAnalytics().subscribe(result => {
    
      if (result.Status == 0) {
        //this.isLogiBuilder = false;
        const elements = document.getElementsByClassName("embedDash")[0];
        if (elements != undefined)
          elements.innerHTML = "";
        //this.currentDashboardName = dbName;
        this.currentDashboardName=DashboardName;
        const getToken = async () => {
          return Promise.resolve({ // this is an example function. server side should be called in production 
            "access_token": this.user_Org_Accesstoken,
            "expires_in": "6000"
          });
        }

        const embedManagerPromise = this.window.initComposerEmbedManager({ getToken: getToken });
        console.log(embedManagerPromise);

        const componentConfig = {
          dashboardId: dashboardId, // dashboard id
          "interactivityProfileName": "interactive",
          // "theme": "modern",
          // "editor": { "placement": "dockRight" },
          "interactivityOverrides": {
            "name": "interactive",
            "type": "SYSTEM",
            "overrideVisualInteractivity": true,
            "settings": {
              "REFRESH": true,
              "CHANGE_LAYOUT": false,
              "RENAME": false,
              "SHARE_FILTER_SETS": true,
              "DASHBOARD_INTERACTIONS": false,
              "ADD_TO_FAVORITES": false,
              "DELETE": false,
              "FILTER": true,
              "EXPORT_PNG_PDF": true,
              "ADD_VISUALS": false,
              "EXPORT_CONFIGURATION": false,
              "DASHBOARD_LINKS": false,
              "SAVE": true
            },

          },
          /* END: interactivity profile overrides */
          "theme": "modern",
          "editor": { "placement": "dockRight" },
          "header": {
            "showActions": true,
            "showTitle": false,
            "visible": true
          }
        }

        const createEmbedComponent = (embedManager, config, containerElementId = 'embedDash') => {
          // this.blockUI.start("Updating...");

          return embedManager.createComponent("dashboard", config).then(component => {
            component.render(document.getElementById(containerElementId), { width: "100%", height: "100%" });
            // this.blockUI.stop();

          })
        }

        embedManagerPromise.then(embedManager => {
          createEmbedComponent(embedManager, componentConfig, 'embedDash');
        });

      } else {
        this.commonService.ValidationBanner("The dashboards are getting updated. Kindly revisit after sometime.");
      }
    })
  }
}

export interface Window {
  initComposerEmbedManager: any;
}
